var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeaturesSplitIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.00072544,0.000325437374 C9.25608287,0.000594256335 9.51119386,0.0980938586 9.7058,0.2927 L11.8318,2.4167 C11.8439693,2.42883815 11.8557598,2.44121071 11.8671716,2.45380314 L13.7078,4.2927 C13.9134828,4.49785673 14.0109676,4.76997998 14.0004,5.03876079 L14.0004,16 C14.0004,17.105 13.1044,18 12.0004,18 L2.0004,18 C0.8954,18 0.0004,17.105 0.0004,16 L0.0004,2 C0.0004,0.895 0.8954,0 2.0004,0 L9.0004,0 Z M12.0004,6 L12.0004,16 L2.0004,16 L2.0004,2 L8,2 L8,6 L12.0004,6 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "new-features",
    transform: "translate(-72.000000, -1076.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(72.000000, 1076.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#007FAD",
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("g", {
    id: "split-icon-white",
    transform: "translate(6.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Editing/page",
    transform: "translate(2.727273, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Colors/white",
    mask: "url(#mask-2)",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3",
    x: 0,
    y: 0,
    width: 14,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 8.181818)",
    stroke: "#FFFFFF",
    strokeDasharray: "3,3",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.33333333 L20,1.33333333",
    id: "Line"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesSplitIcon);
export default __webpack_public_path__ + "static/media/features-split-icon.4cae662a6caafe447a21f0b303351999.svg";
export { ForwardRef as ReactComponent };